import { Link } from '../../lib/routing/ViedmaNavigation';
import { useTheme } from '../../context/ThemeContext';
import { useMySchoolProfile } from '../../hooks/useMySchoolProfile';
import './BrandLogo.css';

const BRANDING = {
  icon: '/branding/abjd-icon.png',
  fullLight: '/branding/logo-minimal.png',
  fullDark: '/branding/logo-minimal-dark.png',
};

const VARIANTS = {
  sidebar: {
    wrapper: 'brand-logo--sidebar',
    iconImage: 'brand-logo__icon-image--sidebar',
    fullImage: 'brand-logo__full-image--sidebar',
  },
  mobile: {
    wrapper: 'brand-logo--mobile',
    iconImage: 'brand-logo__icon-image--mobile',
    fullImage: 'brand-logo__full-image--mobile',
  },
  guest: {
    wrapper: 'brand-logo--guest',
    iconImage: 'brand-logo__icon-image--guest',
    fullImage: 'brand-logo__full-image--guest',
  },
};

export default function BrandLogo({
  to = '/app',
  brand,
  variant = 'sidebar',
  className = '',
  onClick,
  expanded = false,
}) {
  const { isDark } = useTheme();
  const { hasProfile: hasSchoolProfile } = useMySchoolProfile();
  const styles = VARIANTS[variant] || VARIANTS.sidebar;
  const showFullLogo = variant === 'sidebar' ? expanded : true;
  const fullLogoSrc = isDark ? BRANDING.fullDark : BRANDING.fullLight;
  const resolvedTo = to && to !== '/app' ? to : (hasSchoolProfile ? '/school' : (to || '/app'));

  if (brand === 'viedma') {
    const viedmaTo = to && to !== '/app' ? to : '/app/viedma';
    return (
      <Link
        to={viedmaTo}
        onClick={onClick}
        aria-label="Viedma home"
        className={`viedma-brand flex flex-col items-start text-start justify-center whitespace-nowrap shrink-0 ${className}`.trim()}
      >
        <span className="font-black text-2xl sm:text-3xl font-sans tracking-wide leading-none flex items-center select-none" dir="ltr" aria-label="VIEDMA">
          <span style={{ color: '#2b7fb3' }}>V</span>
          <span className="text-slate-700 dark:text-slate-200">I</span>
          <span style={{ color: '#e94330' }}>E</span>
          <span style={{ color: '#d97706' }}>D</span>
          <span style={{ color: '#2b7fb3' }}>M</span>
          <span style={{ color: '#16a34a' }}>A</span>
        </span>
        {showFullLogo && (
          <span className="text-[10px] font-bold tracking-wider text-slate-500 dark:text-slate-400 uppercase mt-0.5 select-none" dir="ltr">
            STEAM • Learner’s Edition
          </span>
        )}
      </Link>
    );
  }

  if (brand === 'quran') {
    const quranTo = to && to !== '/app' ? to : '/quran';
    return (
      <Link
        to={quranTo}
        onClick={onClick}
        aria-label="Quran home"
        className={`quran-brand flex items-center gap-2.5 select-none whitespace-nowrap shrink-0 ${className}`.trim()}
      >
        <div className="w-10 h-10 shrink-0 relative flex items-center justify-center">
          <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-xs" aria-hidden="true">
            <rect x="14" y="14" width="72" height="72" rx="9" fill="#0d382c" stroke="#c59b27" strokeWidth="4.5" />
            <rect x="14" y="14" width="72" height="72" rx="9" transform="rotate(45 50 50)" fill="#0d382c" stroke="#c59b27" strokeWidth="4.5" />
            <circle cx="50" cy="50" r="28" fill="#144d3d" stroke="#c59b27" strokeWidth="2.5" strokeDasharray="3.5 3" />
            <circle cx="50" cy="50" r="22.5" fill="none" stroke="#c59b27" strokeWidth="1.5" />
            <path d="M50 43 C46 39 37 38 31 40 L31 63 C37 61 46 62 50 66 C54 62 63 61 69 63 L69 40 C63 38 54 39 50 43 Z" fill="#ffffff" stroke="#c59b27" strokeWidth="1.2" />
            <path d="M50 43 L50 66" stroke="#c59b27" strokeWidth="1.6" />
          </svg>
        </div>
        {showFullLogo && (
          <div className="flex flex-col text-start whitespace-nowrap shrink-0">
            <span className="text-base sm:text-lg font-extrabold text-[#0d382c] dark:text-[#f7f4ea] leading-tight font-amiri">
              منصة القرآن الكريم
            </span>
            <span className="text-[11px] font-semibold text-[#c59b27] dark:text-[#e2bc56] leading-none font-amiri">
              اقرأ وارتقِ
            </span>
          </div>
        )}
      </Link>
    );
  }

  return (
    <Link
      to={resolvedTo}
      onClick={onClick}
      aria-label="Abjd home"
      className={`brand-logo ${styles.wrapper} ${showFullLogo ? 'brand-logo--expanded' : 'brand-logo--collapsed'} ${className}`.trim()}
    >
      <span className="brand-logo__viewport">
        <img
          src={BRANDING.icon}
          alt=""
          aria-hidden="true"
          className={`brand-logo__image brand-logo__icon-image ${styles.iconImage}`}
        />
        <img
          src={fullLogoSrc}
          alt="Abjd"
          className={`brand-logo__image brand-logo__full-image ${styles.fullImage}`}
        />
      </span>
    </Link>
  );
}
